<template>
  <div
    v-if="text"
    class="caption mb-1">
    {{ text }}<span
      v-if="required"
      class="red--text"
    >*</span>
  </div>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/elements/VCaption.vue